const { css } = require('styled-components');

module.exports.SINGLE_LINE_FIELD_HEIGHT = 56;
module.exports.SINGLE_LINE_INPUT_HEIGHT = 23;
module.exports.FIELD_LABEL_COLOR = '#5f6368';

module.exports.fieldLabelColorStyles = `
    label.MuiInputLabel-root:not(.Mui-error):not(.Mui-disabled) {
        color: ${module.exports.FIELD_LABEL_COLOR} !important;
    }
`;

module.exports.source = `
    width: 100%;
    margin: 0;

    ${module.exports.fieldLabelColorStyles}

    &.MuiFormControl-root,
    div.MuiFormControl-root {
        padding: 0;
        min-height: ${module.exports.SINGLE_LINE_FIELD_HEIGHT}px !important;
        height: auto !important;
    }

    label.MuiFormLabel-root:not(.MuiInputLabel-filled) {
        margin-top: 10px !important;
        height: ${module.exports.SINGLE_LINE_INPUT_HEIGHT}px !important;
        line-height: ${module.exports.SINGLE_LINE_INPUT_HEIGHT}px !important;
    }

    div.MuiInput-root {
        margin-top: 16px !important;
    }

    div.MuiInputBase-root {
        position: relative;
    }

    div.MuiFilledInput-root {
        margin-top: 0 !important;
        min-height: ${module.exports.SINGLE_LINE_FIELD_HEIGHT}px !important;
    }

    .MuiInput-underline:before {
        height: 2px !important;
    }

    input.MuiInput-input {
        height: ${module.exports.SINGLE_LINE_INPUT_HEIGHT}px !important;
        line-height: ${module.exports.SINGLE_LINE_INPUT_HEIGHT}px !important;
        padding-top: 4px !important;
        padding-bottom: 5px !important;
        box-sizing: content-box;
    }

    .MuiFormHelperText-root {
        position: relative;
        margin-top: 3px;
        line-height: 1em;
    }

    .MuiFormHelperText-root:not(.Mui-error),
    .MuiFormHelperText-root:empty {
        display: none !important;
        margin-top: 0;
    }
`;

module.exports.singleLineFieldStyles = css`${module.exports.source}`;
